import newLot from './newLot';

const newLotReducers = {
  newLot,
};

export default newLotReducers;


// WEBPACK FOOTER //
// ./src/pages/NEW_LOTE_PAGE/reducers/index.js